export default __webpack_public_path__ + "static/media/EM0999.34I-41718_-25012_0.a410c277.jpg";